import { useParams } from 'react-router-dom'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { FormElement, FormRender } from '../../../../../../../forms/FormRenderer/types'
import { BillingTypeBuyModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeBuy'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { BillingGroupPayload } from '../../../../../../../utils/reducers/company/billingGroups'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { ConnectedProps, connect } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'



type ModalCEConfigBillingTypeBuyProps = ModalEditComponentProps & ReduxModalCEConfigBillingTypeBuyConnector & {}

const ModalCEConfigBillingTypeBuy: React.FC<ModalCEConfigBillingTypeBuyProps> = ({ allRowData, userPermissions, billingGroups, ...rest }) => {
    const { t } = useTwinTranslation()
    const { BillingGroupId } = useParams()
    const byDefault: FormElement<keyof BillingTypeBuyModelType>[] = []
    if (BillingGroupId && allRowData) {
        const billingTypesBuy = billingGroups?.dictionaryBillingGroup?.[parseInt(BillingGroupId)]?.billingTypesBuyDict || {}
        const billingTypeBuy = billingTypesBuy[allRowData.id]
        byDefault.push(
            {
                name: 'DefaultBillingTypeBuyOptionId',
                label: t('byDefault', 'Por defecto'),
                component: 'CustomSelect',
                items: billingTypeBuy?.billingTypeBuyOptionsDict || {},
                value: allRowData['DefaultBillingTypeBuyOptionId']
            },
            {
                name: 'BuyServiceShippingBTBOId',
                label: t('byDefaultForBuyServiceShipping', 'Por defecto para Facturas de Gasto de Transporte'),
                component: 'CustomSelect',
                items: billingTypeBuy?.billingTypeBuyOptionsDict || {},
                value: allRowData['BuyServiceShippingBTBOId']
            }
        )
    }
    const fields: FormRender<BillingTypeBuyModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'mandatory',
                    label: t('mandatory', 'Obligatorio'),
                    component: 'CheckboxMargin',
                },

                {
                    name: 'id',
                    component: 'InputHidden'
                },
                {
                    name: 'BillingGroupId',
                    component: 'InputHidden',
                    value: BillingGroupId
                },
                ...byDefault
            ]
        },
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/billingGroup/billingTypeBuy/updateBillingTypeBuy'} translations={{ title: t('editBillingTypeBuy', 'Editar Tipo de facturación'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/billingGroup/billingTypeBuy/createBillingTypeBuy'} translations={{
        title: t('createBillingTypeBuy', 'Crear Tipo de Facturación'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

const modalCEConfigBillingTypeBuyDispatch = {
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalCEConfigBillingTypeBuyConnector = (state: AllReduxPayloads) => ({ billingGroups: state.billingGroups })
const modalCEConfigBillingTypeBuyConnector = connect(mapModalCEConfigBillingTypeBuyConnector, modalCEConfigBillingTypeBuyDispatch)
type ReduxModalCEConfigBillingTypeBuyConnector = ConnectedProps<typeof modalCEConfigBillingTypeBuyConnector>

const modalCEConfigBillingTypeBuyConnectLoading = withLoading(ModalCEConfigBillingTypeBuy, [{ fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups' }])
const ModalCEConfigBillingTypeBuyConnect = modalCEConfigBillingTypeBuyConnector(modalCEConfigBillingTypeBuyConnectLoading)

export default ModalCEConfigBillingTypeBuyConnect